import { render, staticRenderFns } from "./YouAreHere.vue?vue&type=template&id=b5d5e7bc&scoped=true"
import script from "./YouAreHere.vue?vue&type=script&lang=ts"
export * from "./YouAreHere.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d5e7bc",
  null
  
)

export default component.exports